import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { SearchSelect } from './inputs/search-select';
import { DateInput } from '../common/helpers/DateComponent';
import { todayDate } from '../common/helpers/TodayDate';
import { normalstyle } from '../../../functions/welding-functions';
const WelderReportFilters = ({
  wiobj,
  setwiobj,
  error,
  setError,
  uniqueProjectNumbers,
  jointOptions,
  welderOptions,
  slipStatusOptions,
  onProjectChange,
  onJointChange,
  onWelderChange,
  onSlipStatusChange,
  showFileFormat = false,
  fileFormatOptions = [],
}) => {
  return (
    
    <div className="px-2 pb-2">
      <Row className="gx-3" style={{ marginBottom: "1px" }}>
        <Col md={3} >
          <Form.Group className="ListW-input-select">
            <div className="search-select" >
              <SearchSelect
                id="WI_Project_No"
                name="WI_Project_No"
                stylegreen={normalstyle}
                data={uniqueProjectNumbers.map(projectNo => ({
                  WI_Project_No: projectNo,
                }))}
                valueField="WI_Project_No"
                value={wiobj?.WI_Project_No}
                labelField="WI_Project_No"
                placeholder=""
                onChange={(selected) => onProjectChange(selected.value)}
                styles={{ width: "100%" }}
              />
            </div>
            <Form.Label>Project Number</Form.Label>
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group className="ListW-input-select">
            <div className="search-select">
              <SearchSelect
                id="WI_Joint_No"
                name="WI_Joint_No"
                data={jointOptions}
                valueField="value"
                value={wiobj?.WI_Joint_No}
                labelField="label"
                stylegreen={normalstyle}
                placeholder=""
                onChange={(selected) => onJointChange(selected.value)}
              />
            </div>
            <Form.Label>Joint</Form.Label>
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group className="ListW-input-select">
            <div className="search-select">
              <SearchSelect
                id="WI_Welder_Id"
                name="WI_Welder_Id"
                data={welderOptions}
                valueField="value"
                value={wiobj?.WI_Welder_Id}
                labelField="label"
                stylegreen={normalstyle}
                placeholder=""
                onChange={(selected) => onWelderChange(selected.value)}
              />
            </div>
            <Form.Label>Welder Code</Form.Label>
          </Form.Group>
        </Col>

        <Col md={3}>
          <DateInput
            divClass="Date-input w-100"
            label="Slip Creation Date From"
            className="groove_datecolor"
            name="WI_From_Date"
            todayDate={todayDate}
            obj={wiobj}
            setobj={setwiobj}
            todate={wiobj.WI_To_Date}
            setError={setError}
            status={error.WI_From_Date.status}
            message={error.WI_From_Date.message}
          />
        </Col>
      </Row>

      <Row className="gx-3" style={{ marginBottom: "1px" }}>
        <Col md={3}>
          <DateInput
            divClass="Date-input w-100"
            label="Slip Creation Date To"
            className="groove_datecolor"
            name="WI_To_Date"
            todayDate={todayDate}
            obj={wiobj}
            fromdate={wiobj.WI_From_Date}
            setobj={setwiobj}
            setError={setError}
            status={error.WI_To_Date.status}
            message={error.WI_To_Date.message}
          />
        </Col>

        <Col md={3}>
          <Form.Group className="ListW-input-select">
            <div className="search-select">
              <SearchSelect
                id="WI_Slip_Status"
                name="WI_Slip_Status"
                data={slipStatusOptions}
                valueField="value"
                value={wiobj?.WI_Slip_Status}
                labelField="name"
                placeholder=""
                stylegreen={normalstyle}
                onChange={(selected) => onSlipStatusChange(selected.value)}
              />
            </div>
            <Form.Label>Slip Status</Form.Label>
          </Form.Group>
        </Col>

        {showFileFormat && (
          <Col md={3}>
            <Form.Group className="ListW-input-select">
              <div className="search-select">
                <SearchSelect
                  id="WI_FileFormat"
                  name="WI_FileFormat"
                  data={fileFormatOptions}
                  valueField="value"
                  value={wiobj?.WI_FileFormat}
                  labelField="name"
                  placeholder=""
                  stylegreen={normalstyle}
                  onChange={(selected) => 
                    setwiobj(prev => ({ ...prev, WI_FileFormat: selected.value }))
                  }
                />
              </div>
              <Form.Label>File Format</Form.Label>
            </Form.Group>
          </Col>
        )}
        <Col md={3}></Col>
      </Row>
    </div>
  );
};

export default WelderReportFilters;